import { useEffect, useState } from "react";
import { getPoItem } from "src/services/po-api";
import { useToast } from "src/hooks/useToast";
import { Spinner } from "src/components";
import moment from "moment";


const CNAdvice = ({ orderProductId, company_code }: any) => {
    const [poDetails, setPoDetails] = useState<any>([]);
    const [isLoading, setIsLoading] = useState(false);

    const { toast } = useToast();

    const fetchPoDetails = async () => {
        setIsLoading(true);
        let payload;

        payload = {
            order_product_id: orderProductId,
            company_code: company_code,
            tab_type:'CN'
        };
        try {
            const response = await getPoItem(payload);
            setPoDetails(response?.data?.data?.invoiceProductMappings);
        } catch (error: any) {
            console.log(error);
            toast({
                title: "Error",
                description: error?.response?.data?.message || "Something went wrong",
                variant: "destructive",
            });
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchPoDetails();
    }, [orderProductId]);

    return (
        <div>
            {isLoading ? (
                <div className="flex justify-center items-center">
                    <Spinner size="small" />
                </div>
            ) : poDetails?.length > 0 ? (
                <div className="overflow-x-scroll">
                    <table className="min-w-full mt-2 border">
                        <thead className="w-full">
                            <tr>
                                <th className="px-4 py-1 text-[.8rem] font-normal text-left text-[#B5B5B5] border">PO Number</th>
                                <th className="px-4 py-1 text-[.8rem] font-normal text-left text-[#B5B5B5] border">PO Date</th>
                                <th className="px-4 py-1 text-[.8rem] font-normal text-left text-[#B5B5B5] border">PO Item Code</th>
                                <th className="px-4 py-1 text-[.8rem] font-normal text-left text-[#B5B5B5] border">Plant Code</th>
                                <th className="px-4 py-1 text-[.8rem] font-normal text-left text-[#B5B5B5] border">Company Stockist Code</th>
                                <th className="px-4 py-1 text-[.8rem] font-normal text-left text-[#B5B5B5] border">Quantity</th>
                                <th className="px-4 py-1 text-[.8rem] font-normal text-left text-[#B5B5B5] border">{poDetails?.[0]?.po_item?.price_identifier === 1 ? "Discount on PTR" : (poDetails?.[0]?.po_item?.price_identifier === 2 ? "Scheme" : "Fixed Price")}</th>
                                <th className="px-4 py-1 text-[.8rem] font-normal text-left text-[#B5B5B5] border">Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            {poDetails?.map((item: any) => (
                                <tr key={item?.invoice_product_order_product_id} className="text-sm">
                                    <td className="px-4 py-1 text-[.8rem] border">{item?.po_item?.purchaseOrder?.po_number}</td>
                                    <td className="px-4 py-1 text-[.8rem] border">{moment(item?.po_item?.purchaseOrder?.created_date).format("DD-MM-YYYY h:mm a")}</td>
                                    <td className="px-4 py-1 text-[.8rem] border">{item?.po_item?.item_code_po}</td>
                                    <td className="px-4 py-1 text-[.8rem] border">{item?.po_item?.plant_code}</td>
                                    <td className="px-4 py-1 text-[.8rem] border">{item?.po_item?.purchaseOrder?.compStockistAliasCode}</td>
                                    <td className="px-4 py-1 text-[.8rem] border">{item?.po_item?.invoiced_qty}</td>
                                    <td className="px-4 py-1 text-[.8rem]  border">{item?.po_item?.price_identifier === 1 ? item?.po_item?.final_discount_perc : (item?.po_item?.price_identifier === 2 ? item?.po_item?.invoiced_free_qty : item?.po_item?.final_fixed_price)}</td>
                                    <td className="px-4 py-1 text-[.8rem] border">{item?.po_item?.line_amount}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            ) : (
                <div className="mt-2 text-center text-sm text-[#B5B5B5]">No data found</div>
            )}
        </div>
    );
};

export default CNAdvice;
